export class AnnouncementIdParametersDto {
    announcementId: number;

    constructor(announcementId?: number) {
        this.announcementId = announcementId;
    }
}
